import React,{createContext,useContext,useReducer} from 'react';

// crea el contexto que es como el momento o memoria global del app
export const StateContext = createContext();   

// representa una variable en la cual se registran a todos los componentes que pueden acceder al contexto como una suscripcion
// reducer -> Mecanismo para poder cambiar valores de caracter global en el app
// InitialState -> almacena el estado actual de mis variables
// children -> Son todos los componentes que se suscriben para poder ver o setear valores de las variables globales 
export const StateProvider = ({reducer,initialState,children})=>(
    
    // realiza la suscripcion 
    <StateContext.Provider value = {useReducer(reducer,initialState)}>
        {children}
    </StateContext.Provider>
);


// permite tener acceso a todas las variables de sesion que han definido en el contexto 
export const useStateValue = () => useContext(StateContext);